import { render, staticRenderFns } from "./CreditNote.vue?vue&type=template&id=96018a3c&"
import script from "./CreditNote.vue?vue&type=script&lang=js&"
export * from "./CreditNote.vue?vue&type=script&lang=js&"
import style0 from "./CreditNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports